import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import Select from "material-ui/Select";
import Button from "../../../Parts/Button";

const styles = () => ({
  root: {
    padding: "60px 0",
    width: "100%",
  },

  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    border: "1px solid #E7E9EB",
    background: "#FFFFFF",
    padding: "40px 44px",
    width: "492px",
    boxSizing: "border-box",
    margin: "auto",
  },

  title: {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "26px",
  },

  desc: {
    fontSize: "14px",
    marginBottom: "32px",
  },

  formControl: {
    width: "100%",
    marginBottom: "40px",
  },

  buttonContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
});

class SalesforceSelectObject extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="title" className={classes.title}>
            Salesforceオブジェクトを選択
          </Typography>
          <Typography variant="body2" className={classes.desc}>
            同期するSalesforceオブジェクトを選択してください。
          </Typography>
          <FormControl className={classes.formControl}>
            <Select
              value={this.props.sobject}
              onChange={this.props.handleSelectSobject}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
              }}
              classes={{ select: classes.select }}
              disableUnderline
            >
              <MenuItem key={-1} value={0}>
                選択してください
              </MenuItem>

              {this.props.menu.map((item, i) => (
                <MenuItem key={i} value={item.value}>
                  {item.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={classes.buttonContainer}>
            {this.props.prev && (
              <Button
                text="戻る"
                type="line"
                size="large"
                handleClickButton={this.props.prev}
                style={{ marginRight: "20px" }}
              ></Button>
            )}
            <Button
              text="次へ"
              size="large"
              loading={this.props.isLoading}
              disabled={this.props.sobject === 0}
              handleClickButton={this.props.next}
            ></Button>
          </div>
        </div>
      </div>
    );
  }
}

SalesforceSelectObject.propTypes = {
  classes: PropTypes.object.isRequired,
  sobject: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number // TODO 初期値を0にしてるためだが、そもそも初期値を見直した方がよさそう
  ]),
  menu: PropTypes.array,
  handleSelectSobject: PropTypes.func.isRequired,
  next: PropTypes.func,
  prev: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default withStyles(styles)(SalesforceSelectObject);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceSelectObject.jsx